import React, { Fragment, useEffect, useState } from "react";
import InfoEditCard from "../../components/Cards/InfoEditCard";
import InfoAddCard from "../../components/Cards/InfoAddCard";
import { FaGraduationCap, FaShare, FaUserTie } from "react-icons/fa";
import { PiBagFill } from "react-icons/pi";
import { HiLightBulb } from "react-icons/hi";
import axiosInstance from "../../services/api/axiosInstance";
import CandidateProfile from "./CandidateProfile";
import Joyride, { STATUS } from "react-joyride";
import images from "../../utils/images";
import Cookie from "js-cookie";
import { MdClear } from "react-icons/md";
import { IoIosCloseCircleOutline, IoIosSearch } from "react-icons/io";
import toast from "react-hot-toast";
import InputGroup from "components/Input/InputGroup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import { decryptData, encryptData } from "Security/Crypto/Crypto";
import { Card } from "react-bootstrap";
import { IoChevronBackCircle, IoFilterSharp } from "react-icons/io5";
import ReactPaginate from "react-paginate";
import { PoolFilter } from "./PoolFilter";
import JsonData from "utils/JsonData";
import { useSelector } from "react-redux";
import { reset_all_states_to_default } from "Slices/commonSlices/milleSearchFilter";
import { useDispatch } from "ReusableFunctions/CustomHooks";

const EmployerPool = () => {
  const dispatch = useDispatch();
  const { jsonOnly } = JsonData();
  const { location } = useSelector((state) => state.milleSearchStates);

  const [pageContentLoaded, setPageContentLoaded] = useState(false);
  const [allArrayData, setAllArrayData] = useState([]);
  const [shareProfessional, setShareProfessional] = useState(null);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState(null);
  const [professionalId, setProfessionalId] = useState(null);
  const [poolSearch, setPoolSearch] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [empJobGlow, gettingEmpJobGlow] = useState(false)
  const [empJobsData, setEmpJobsData] = useState([]);

  const [sendInviteData, setSendInviteData] = useState({
    professional_id: '',
    job_id: '',
    employer_feedback: '',
    employer_feedback: ''
  })

  const [isShared, setIsShared] = useState(null)
  const [cookieProfId, setCookieProfId] = useState(Cookie.get("Prof_id"));
  const [cookieProfIdPartner, setCookieProfIdPartner] = useState(Cookie.get("prof_id_partner"));
  const [mobileScreen, setMobileScreen] = useState(window.innerWidth);

  //modal handling
  const [show, setShow] = useState(false);
  const [inviteInterviewBtn, setInviteInterviewBtn] = useState(false);
  const [runForNoData, setRunForNoData] = useState(false);
  const [run, setRun] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [poolFilter, setPoolFilter] = useState(false);
  const [genderFilter, setGenderFilter] = useState([]);
  const [industrySectorOptions, setindustrySectorOptions] = useState(jsonOnly?.industry_sector || []);
  const [industrySectorFilter, setIndustrySectorFilter] = useState([]);
  const [sectorOptions, setSectorOptions] = useState(jsonOnly?.sectors || []);
  const [sectorFilter, setSectorFilter] = useState([]);
  const [functionalSpecificationOptions, setFunctionalSpecificationOptions] = useState(jsonOnly?.functional_specialization || []);
  const [functionalSpecification, setFunctionalSpecification] = useState([]);
  const [jobTypeFilter, setJobTypeFilter] = useState([]);
  const [willingToRelocateFilter, setwillingToRelocateFilter] = useState([]);
  const [locationPreferenceFilter, setLocationPreferenceFilter] = useState([]);
  const [isMilleSearchFiltered, setIsMilleSearchFiltered] = useState(false);
  const [poolApplyFilterObject, setPoolApplyFilterObject] = useState({});
  const [filterGlow, setFilterGlow] = useState(false);
  const handleInterviewModal = () => setShow(!show);

  // JOYRIDE
  const stepsForNoData = [
    {
      target: "body",
      content: (
        <div className="text-center">
          <h4 className="fw-bold mb-4">Welcome to the Talent Pool!</h4>
          <p>
            Explore profiles of top talents, view their skills, experience, and
            education. If there is any profile that matches your requirements,
            please contact 2nd Careers. We will be happy to connect you. Let's
            get started!
          </p>
        </div>
      ),
      placement: "center",
    },
    {
      target: "#searchInputField",
      content:
        "Search Bar Use the search bar to quickly find candidates based on specific skills, experience, education, or organization names. Start typing to see suggestions and filter results efficiently.",
      placement: "bottom",
    },
  ];

  const steps = [
    {
      target: "body",
      content: (
        <div className="text-center">
          <h4 className="fw-bold mb-4">Welcome to the Talent Pool!</h4>
          <p>
            Explore profiles of top talents, view their skills, experience, and
            education. If there is any profile that matches your requirements,
            please contact 2nd Careers. We will be happy to connect you. Let's
            get started!
          </p>
        </div>
      ),
      placement: "center",
    },
    {
      target: "#firstCard",
      content:
        "Each profile card provides a snapshot of the candidate's key information.",
      placement: "top",
    },
    {
      target: "#clickToSeeProfile2",
      content:
        "Click here to access detailed information about the candidate, including their complete work history, skills, education, and more.",
      placement: "top",
    },
    {
      target: "#searchInputField",
      content:
        "Search Bar Use the search bar to quickly find candidates based on specific skills, experience, education, or organization names. Start typing to see suggestions and filter results efficiently.",
      placement: "bottom",
    },
  ];

  useEffect(() => {
    setRun(true);
    setRunForNoData(true);

    if (window.location.pathname === "/employer_dashboard/pool") setInviteInterviewBtn(true);
  }, []);

  useEffect(() => {
    let id = null;
    let params = {
      id: 0,
      location: [],
      gender: [],
      industry_sector: [],
      job_type: [],
      sector: [],
      willing_to_relocate: [],
      functional_specification: [],
      location_preference: [],
      search_text: "",
      page_number: 1,
      flag: "",
      pagination_flag: ""
    }

    if (cookieProfId) id = decryptData(cookieProfId);
    if (cookieProfIdPartner) id = decryptData(cookieProfIdPartner);

    setIsShared(id);
    setCurrentPage(0);
    setPoolApplyFilterObject(params);
    if (id) setProfessionalId(id);
    else getPoolPageResponse(params);
  }, [cookieProfId, cookieProfIdPartner])

  useEffect(() => {
    const cookieChangeHandler = () => {
      setCookieProfId(Cookie.get("Prof_id"));
      setCookieProfIdPartner(Cookie.get("prof_id_partner"));
    };

    const interval = setInterval(cookieChangeHandler, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleJoyrideCallbackForNoData = (data) => {
    const { status } = data;
    if ([STATUS.SKIPPED, STATUS.FINISHED].includes(status)) {
      // Remove a specific cookie
      Cookie.remove("isEmployerPoolFirstVisit");
      Cookie.remove("isPartnerPoolFirstVisit");
    }
  };

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if ([STATUS.SKIPPED, STATUS.FINISHED].includes(status)) {
      // Remove a specific cookie
      Cookie.remove("isEmployerPoolFirstVisit");
      Cookie.remove("isPartnerPoolFirstVisit");
    }
  };

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 588) setMobileScreen(screenWidth);
    else setMobileScreen(null);
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //search input enter key down
  const handlekeydown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (poolSearch) {
        setIsSearched(true);
        clickSearchIcon();
      } else {
        toast.error("search field is empty");
      }
    }
  };

  const getPoolPageResponse = async (params) => {
    setAllArrayData([]);
    setTotalNoOfRecords(0);
    setPageContentLoaded(false);

    try {
      const response = await axiosInstance.post("/pool_dashboard_view", params);
      if (response.data.error_code === 0) {
        setPageContentLoaded(true);
        setAllArrayData(response.data.data.final_result);
        setTotalNoOfRecords(response.data.data.total_professionals);
      } else {
        setAllArrayData([]);
        setPageContentLoaded(true);
      }
      setPoolFilter(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleInviteTonterview = async (prof_id) => {
    gettingEmpJobGlow(true);
    try {
      setShow(true)
      const { data } = await axiosInstance.post("fetch_employer_jobs", {
        professional_id: prof_id
      })

      if (data?.error_code === 0) {
        gettingEmpJobGlow(false);
        setEmpJobsData(data?.data)

      } else {
        gettingEmpJobGlow(false);
        setShow(false)
      }
    } catch (err) {
      console.log(err)
      setShow(false)
    }
  }

  const handleSelecJob = (e) => {
    if (e) {
      const parseJob = JSON.parse(e)
      const selectedObj = empJobsData?.filter((value) => value?.id === parseJob?.id);

      if (selectedObj?.length) {
        setSendInviteData({
          ...sendInviteData,
          job_id: selectedObj[0]?.id,
          professional_id: selectedObj[0]?.professional_id
        })
      } else {
        setSendInviteData({
          ...sendInviteData,
          job_id: '',
          professional_id: '',
          employer_feedback: ''
        })
      }
    }
  }

  const handleInterviewApi = async () => {
    try {
      if (sendInviteData?.professional_id) {
        const { data } = await axiosInstance.post("/invite_by_employer", { ...sendInviteData, invite_from: "pool_page" })
        if (data.error_code === 0) {
          setShow(false);
          setSendInviteData({
            job_id: '',
            professional_id: '',
            employer_feedback: ''
          })
        } else {
          toast.error(data?.message)
        }
      } else {
        toast.error("please select the job")
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleCopytext = (share_link) => {
    navigator.clipboard.writeText(share_link);
    toast.success("Link copied");
  };

  function handleResetMellieSearcchFilter() {
    setGenderFilter([])
    setIndustrySectorFilter([])
    setSectorFilter([])
    setJobTypeFilter([])
    setwillingToRelocateFilter([])
    setLocationPreferenceFilter([])
    setFunctionalSpecification([])
    dispatch(reset_all_states_to_default())
  }

  function handle_clear_user_searches(clear_params) {
    setCurrentPage(0)
    let object;

    if ((!isSearched && !isMilleSearchFiltered) || (clear_params === "search" && !isMilleSearchFiltered) || (clear_params === "clear filter" && !isSearched)) {
      if (clear_params === "search") {
        setIsSearched(false)
        setPoolSearch('')
      }

      if (clear_params === "clear filter") {
        setIsMilleSearchFiltered(false)
        handleResetMellieSearcchFilter()
      }
      object = {
        id: 0,
        page_number: 1
      }

      getPoolPageResponse(object);
      return
    }

    if (clear_params === "search") {
      setIsSearched(false)
      setPoolSearch('')

      var gender = genderFilter.map((v) => v.label)
      var industry_sector = industrySectorFilter.map((v) => v.label)
      var job_type = jobTypeFilter.map((v) => v.label)
      var sector = sectorFilter.map((v) => v.label)
      var functional_specification = functionalSpecification.map((v) => v.label)
      var willing_to_relocate = willingToRelocateFilter.map((v) => v.label)
      var location_preference = locationPreferenceFilter.map((v) => v.label)
      const locationConvertion = location.map((v) => {
        const originalVal = v.split(',')
        const joinOriginalValue = originalVal.join('&&&&&')

        return joinOriginalValue
      })

      if (isMilleSearchFiltered) {
        object = {
          location: locationConvertion,
          gender,
          industry_sector,
          job_type,
          sector,
          willing_to_relocate,
          functional_specification,
          location_preference,
          search_text: '',
          page_number: 1
        }
      } else {
        object = {
          location: [],
          gender: [],
          industry_sector: [],
          job_type: [],
          sector: [],
          willing_to_relocate: [],
          functional_specification: [],
          location_preference: [],
          search_text: "",
          page_number: 1
        }
      }
    } else {
      setIsMilleSearchFiltered(false)
      object = {
        location: [],
        gender: [],
        industry_sector: [],
        job_type: [],
        sector: [],
        willing_to_relocate: [],
        functional_specification: [],
        location_preference: [],
        search_text: isSearched ? poolSearch : '',
        page_number: 1
      }
      handleResetMellieSearcchFilter()
    }

    object.flag = ""
    object.pagination_flag = ""
    setPoolApplyFilterObject(object);
    handlePoolPageFilter(object)
  }

  function clickSearchIcon() {
    setIsSearched(true)
    setCurrentPage(0);

    var gender = genderFilter.map((v) => v.label)
    var industry_sector = industrySectorFilter.map((v) => v.label)
    var job_type = jobTypeFilter.map((v) => v.label)
    var sector = sectorFilter.map((v) => v.label)
    var functional_specification = functionalSpecification.map((v) => v.label)
    var willing_to_relocate = willingToRelocateFilter.map((v) => v.label)
    var location_preference = locationPreferenceFilter.map((v) => v.label)
    const locationConvertion = location.map((v) => {
      const originalVal = v.split(',')
      const joinOriginalValue = originalVal.join('&&&&&')

      return joinOriginalValue
    })

    let searching_txt = /^\d{6}$/.test(poolSearch?.toString()) ? `2C-PR-${poolSearch}` : poolSearch;

    let object;
    if (isMilleSearchFiltered) {
      object = {
        location: locationConvertion,
        gender,
        industry_sector,
        job_type,
        sector,
        willing_to_relocate,
        functional_specification,
        location_preference,
        search_text: searching_txt,
        page_number: 1
      }
    } else {
      object = {
        location: [],
        gender: [],
        industry_sector: [],
        job_type: [],
        sector: [],
        willing_to_relocate: [],
        functional_specification: [],
        location_preference: [],
        search_text: searching_txt,
        page_number: 1
      }
    }
    object.flag = ""
    object.pagination_flag = ""
    setPoolApplyFilterObject(object);
    handlePoolPageFilter(object);
  }

  function handleMellieSearch(searchType) {
    setCurrentPage(0);
    if (searchType === "ApplyFilter") {
      var getFilterLength = genderFilter.length + industrySectorFilter.length + sectorFilter.length
        + functionalSpecification.length + jobTypeFilter.length + willingToRelocateFilter.length
        + locationPreferenceFilter.length + location.length;

      if (getFilterLength > 0) {
        setIsMilleSearchFiltered(true)

        var gender = genderFilter.map((v) => v.label)
        var industry_sector = industrySectorFilter.map((v) => v.label)
        var job_type = jobTypeFilter.map((v) => v.label)
        var sector = sectorFilter.map((v) => v.label)
        var functional_specification = functionalSpecification.map((v) => v.label)
        var willing_to_relocate = willingToRelocateFilter.map((v) => v.label)
        var location_preference = locationPreferenceFilter.map((v) => v.label)
        const locationConvertion = location.map((v) => {
          const originalVal = v.split(',')
          const joinOriginalValue = originalVal.join('&&&&&')

          return joinOriginalValue
        })

        let object;
        object = {
          location: locationConvertion,
          gender,
          industry_sector,
          job_type,
          sector,
          willing_to_relocate,
          functional_specification,
          location_preference,
          search_text: isSearched ? poolSearch : '',
          page_number: 1
        }

        if (isSearched) {
          object.pagination_flag = "first_page"
          object.flag = "filter_in_search"
        }
        else {
          object.pagination_flag = ""
          object.flag = ""
        }
        setPoolApplyFilterObject(object);
        handlePoolPageFilter(object);
      } else {
        toast.error("fields are empty")
      }
    }
  }

  function handlePageClick(data) {
    setCurrentPage(data.selected);

    if (!isSearched && !isMilleSearchFiltered) {
      let page_updated_params = {
        ...poolApplyFilterObject,
        page_number: data.selected + 1
      }

      setPageContentLoaded(false)
      getPoolPageResponse(page_updated_params);
    }
    else {
      let page_updated_params = {
        ...poolApplyFilterObject,
        page_number: data.selected + 1
      }

      setPoolApplyFilterObject(page_updated_params);
      handlePoolPageFilter(page_updated_params);
    }
  }

  async function handlePoolPageFilter(params) {
    setAllArrayData([]);
    setPoolFilter(false);
    setPageContentLoaded(false);
    setFilterGlow(true);
    setTotalNoOfRecords(0);

    try {
      const response = await axiosInstance.post("/pool_dashboard_search_filter", params);
      if (/200|0/.test(response.data?.error_code)) {
        setAllArrayData(response.data.data?.final_result || []);
        setTotalNoOfRecords(response.data.data?.total_professionals || []);
      }
      else setAllArrayData([]);
      setPageContentLoaded(true);
      setFilterGlow(false);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <div className={isShared ? "homePage-backgroundColor overflow-hidden" : "employer-pool overflow-hidden"}>
        {
          isShared ?
            <div className="d-flex flex-wrap justify-content-center align-items-center py-5">
              <Card className="col-11 col-md-8 col-xl-6 border-0 rounded-4">
                <Card.Header className="bg-transparent py-3 border-0">
                  <button type="button" className="btn btn-outline-secondary d-flex align-items-center gap-2 py-2"
                    onClick={() => {
                      Cookie.remove("Prof_id")
                      Cookie.remove("prof_id_partner")
                      setIsShared(null)
                    }}>
                    <IoChevronBackCircle className="fs-5" /> Back
                  </button>
                </Card.Header>
                <Card.Body className="show_pool_page_professional overflow-scroll">
                  <p className={isShared ? "mb-1" : "d-none"} >
                    USER ID :{" "}
                    <strong>{isShared}</strong>
                  </p>
                  <CandidateProfile
                    professionalId={professionalId}
                    mobileScreen={mobileScreen}
                  />
                </Card.Body>

                {
                  ["/employer_dashboard/pool", "/employer_dashboard/pool/"].includes(window.location.pathname) ?
                    <Card.Footer className="bg-transparent">
                      <div className="col text-end">
                        <button className={Cookie.get("Prof_id") ? "btn btn-brand-color" : "btn placeholder rounded-2"}
                          onClick={() => handleInviteTonterview(decryptData(Cookie.get("Prof_id")))}
                          disabled={!Cookie.get("payment_status") || Cookie.get("payment_status") === "trialing"}
                        >
                          Invite to Apply
                        </button>
                      </div>
                    </Card.Footer>
                    :
                    null
                }
              </Card>
            </div>
            :
            <div className={`container-fluid ${mobileScreen ? "px-3" : "px-5"} overflow-hidden`}>
              <div className="pool_page_header">
                <div className="row pt-3 align-items-end">
                  <div className="col-sm-12 col-lg-3">
                    <p className="showing-results text-secondary mb-0 py-2">
                      {allArrayData.length > 0
                        ? `Showing : ${(currentPage * 10) + 1} - ${(currentPage * 10) + allArrayData.length} of ${totalNoOfRecords} profiles`
                        : `Showing : 0 profiles`}
                    </p>
                  </div>

                  <div className="col-sm-12 col-lg-9 d-flex flex-wrap justify-content-end align-items-center">
                    {/* Filter */}
                    <div className="mt-2 p-0 col-12 col-md-6 col-lg-5 col-xl-4">
                      {
                        !pageContentLoaded && !filterGlow ?
                          <div className='placeholder w-100 rounded-2 py-3'></div>
                          :
                          <div className={`card rounded-3 border-0 w-100 ps-2 ${filterGlow ? "pe-none" : ""}`}>
                            <div className="card-body p-0 cursorPointer ">
                              <div className="d-flex flex-wrap align-items-center py-2 w-100 " onClick={() => setPoolFilter(!poolFilter)}>
                                <div className="col-2 col-lg-1 text-center p-0">
                                  <IoFilterSharp className='fs-4 ' />
                                </div>
                                <div className="col-4">
                                  <p className="mb-0 ps-2 w-100 superAdmin-filter-size-title">
                                    Filter
                                  </p>
                                </div>
                                <div className="col-6 col-lg-7 text-end">
                                  {
                                    isMilleSearchFiltered ?
                                      <button type="button" className="btn btn-transparent border border-brand-color candidate-right-side-btn me-3"
                                        onClick={() => handle_clear_user_searches("clear filter")}
                                      >
                                        Clear Filter
                                      </button>
                                      :
                                      null
                                  }
                                </div>
                              </div>

                              <div className={`${poolFilter ? "pool_filter_box rounded-4 shadow" : "d-none"}`}>
                                <div className="h-100 filter-closet">
                                  <div className="d-flex flex-wrap align-items-center p-3 pb-2 pe-1 sticky-top border-bottom bg-white  start-0 end-0 top-0 bottom-0 w-100 rounded-top-4">
                                    <div className="col">
                                      <h6 className="m-0 fw-bold">Filter</h6>
                                    </div>
                                    <div className="col text-end">
                                      <button className="btn btn-sm border-0">
                                        <IoIosCloseCircleOutline
                                          className="fs-4"
                                          onClick={() => setPoolFilter(!poolFilter)}
                                        />
                                      </button>
                                    </div>
                                  </div>

                                  <PoolFilter
                                    jsonOnly={jsonOnly}
                                    genderFilter={genderFilter}
                                    setGenderFilter={setGenderFilter}
                                    industrySectorOptions={industrySectorOptions}
                                    setindustrySectorOptions={setindustrySectorOptions}
                                    industrySectorFilter={industrySectorFilter}
                                    setIndustrySectorFilter={setIndustrySectorFilter}
                                    sectorOptions={sectorOptions}
                                    setSectorOptions={setSectorOptions}
                                    sectorFilter={sectorFilter}
                                    setSectorFilter={setSectorFilter}
                                    functionalSpecificationOptions={functionalSpecificationOptions}
                                    setFunctionalSpecificationOptions={setFunctionalSpecificationOptions}
                                    functionalSpecification={functionalSpecification}
                                    setFunctionalSpecification={setFunctionalSpecification}
                                    jobTypeFilter={jobTypeFilter}
                                    setJobTypeFilter={setJobTypeFilter}
                                    willingToRelocateFilter={willingToRelocateFilter}
                                    setwillingToRelocateFilter={setwillingToRelocateFilter}
                                    locationPreferenceFilter={locationPreferenceFilter}
                                    setLocationPreferenceFilter={setLocationPreferenceFilter}
                                    handleMellieSearch={handleMellieSearch}
                                  />

                                </div>
                              </div>
                            </div>
                          </div>
                      }
                    </div>

                    {/* Search */}
                    <div className="mt-2 ps-md-3 p-0 col-12 col-md-6 col-lg-4">
                      {
                        !pageContentLoaded && !filterGlow ?
                          <div className='placeholder w-100 rounded-2 py-3'></div>
                          :
                          <div className={pageContentLoaded || poolSearch || filterGlow ? "d-flex position-relative" : "d-none"} >
                            <InputGroup className="home-search-icon fs-5" reIcons={<IoIosSearch />} />

                            <input
                              type="text"
                              className="form-control form-control-lg searchInput candidate-searchInput border-0 px-5 py-0 searchInput-border"
                              placeholder="Search by user id, skill, experience, education"
                              aria-label="default input example"
                              value={poolSearch}
                              onChange={(e) => setPoolSearch(e.target.value)}
                              onKeyDown={handlekeydown}
                              disabled={filterGlow}
                            />

                            {poolSearch ? (
                              <div
                                className="searchButtonClick-superAdmin "
                                title="Search"
                                onClick={clickSearchIcon}
                              >
                                <IoIosSearch />
                              </div>
                            ) : null}

                            <div
                              className={`clearButtonClick-superAdmin ${isSearched ? '' : 'pe-none'}`}
                              title="Clear"
                              onClick={() => handle_clear_user_searches("search")}
                            >
                              <MdClear />
                            </div>
                          </div>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="pool_page_body">
                {!pageContentLoaded ?
                  <Fragment>
                    <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                      <div className="row">
                        <div className="col-lg-6 col-md-12">
                          <InfoEditCard
                            pageContentLoaded={pageContentLoaded}
                            cardHeadingIcon={
                              <FaUserTie
                                className={
                                  pageContentLoaded
                                    ? "me-4 brand-color fs-4"
                                    : "me-4  fs-4 placeholder rounded-2"
                                }
                              />
                            }
                            cardHeading="About"
                            id="pageTop"
                            placeholder="Provide a brief description about yourself"
                            cardContent="about content"
                          />
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <InfoEditCard
                            pageContentLoaded={pageContentLoaded}
                            cardHeadingIcon={
                              <FaUserTie
                                className={
                                  pageContentLoaded
                                    ? "me-4 brand-color fs-4"
                                    : "me-4  fs-4 placeholder rounded-2"
                                }
                              />
                            }
                            cardHeading="About"
                            id="pageTop"
                            placeholder="Provide a brief description about yourself"
                            cardContent="about content"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 col-md-12">
                          <div className="card mt-3 border-0 shadow-sm rounded-4">
                            <div className="card-body">
                              <div className="d-flex justify-content-between ms-1">
                                <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                  <HiLightBulb
                                    className={
                                      pageContentLoaded
                                        ? "me-4 brand-color fs-4"
                                        : "me-4  fs-3 placeholder rounded-2"
                                    }
                                  />
                                  <span
                                    className={
                                      pageContentLoaded
                                        ? ""
                                        : "placeholder px-3 w-100 py-1  rounded-1"
                                    }
                                  >
                                    Skills
                                  </span>
                                </label>
                              </div>

                              <div className="d-flex justify-content-between align-items-center">
                                <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                  <p
                                    className={
                                      pageContentLoaded
                                        ? "mt-0 word-space-content px-0 ms-1"
                                        : "placeholder px-3 py-2 mt-0 rounded-1"
                                    }
                                  >
                                    Your skills will be displayed here
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <InfoEditCard
                            pageContentLoaded={pageContentLoaded}
                            cardHeadingIcon={
                              <FaUserTie
                                className={
                                  pageContentLoaded
                                    ? "me-4 brand-color fs-4"
                                    : "me-4  fs-4 placeholder rounded-2"
                                }
                              />
                            }
                            cardHeading="About"
                            id="pageTop"
                            placeholder="Provide a brief description about yourself"
                            cardContent="about content"
                          />
                        </div>
                      </div>

                      <div className="mt-4 text-end">
                        <button
                          className={
                            pageContentLoaded
                              ? "btn btn-brand-color"
                              : "btn  placeholder rounded-2"
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#fullProfileModal"
                        >
                          Click here to see full profile
                        </button>
                      </div>
                    </div>
                    <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                      <div className="row">
                        <div className="col-lg-6 col-md-12">
                          <InfoEditCard
                            pageContentLoaded={pageContentLoaded}
                            cardHeadingIcon={
                              <FaUserTie
                                className={
                                  pageContentLoaded
                                    ? "me-4 brand-color fs-4"
                                    : "me-4  fs-4 placeholder rounded-2"
                                }
                              />
                            }
                            cardHeading="About"
                            id="pageTop"
                            placeholder="Provide a brief description about yourself"
                            cardContent="about content"
                          />
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <InfoEditCard
                            pageContentLoaded={pageContentLoaded}
                            cardHeadingIcon={
                              <FaUserTie
                                className={
                                  pageContentLoaded
                                    ? "me-4 brand-color fs-4"
                                    : "me-4  fs-4 placeholder rounded-2"
                                }
                              />
                            }
                            cardHeading="About"
                            id="pageTop"
                            placeholder="Provide a brief description about yourself"
                            cardContent="about content"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-6 col-md-12">
                          <div className="card mt-3 border-0 shadow-sm  rounded-4">
                            <div className="card-body">
                              <div className="d-flex justify-content-between ms-1">
                                <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                  <HiLightBulb
                                    className={
                                      pageContentLoaded
                                        ? "me-4 brand-color fs-4"
                                        : "me-4  fs-3 placeholder rounded-2"
                                    }
                                  />
                                  <span
                                    className={
                                      pageContentLoaded
                                        ? ""
                                        : "placeholder px-3 w-100 py-1  rounded-1"
                                    }
                                  >
                                    Skills
                                  </span>
                                </label>
                              </div>

                              <div className="d-flex justify-content-between align-items-center">
                                <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                  <p
                                    className={
                                      pageContentLoaded
                                        ? "mt-0 word-space-content px-0 ms-1"
                                        : "placeholder px-3 py-2 mt-0 rounded-1"
                                    }
                                  >
                                    Your skills will be displayed here
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <InfoEditCard
                            pageContentLoaded={pageContentLoaded}
                            cardHeadingIcon={
                              <FaUserTie
                                className={
                                  pageContentLoaded
                                    ? "me-4 brand-color fs-4"
                                    : "me-4  fs-4 placeholder rounded-2"
                                }
                              />
                            }
                            cardHeading="About"
                            id="pageTop"
                            placeholder="Provide a brief description about yourself"
                            cardContent="about content"
                          />
                        </div>
                      </div>

                      <div className="mt-4 text-end">
                        <button
                          className={
                            pageContentLoaded
                              ? "btn btn-brand-color"
                              : "btn  placeholder rounded-2"
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#fullProfileModal"
                        >
                          Click here to see full profile
                        </button>
                      </div>
                    </div>
                  </Fragment>
                  :
                  allArrayData.length ?
                    allArrayData.map((value, i) => {
                      return (
                        <React.Fragment key={value.id}>
                          {!value?.about &&
                            !value?.experience?.length &&
                            !value?.skills?.length &&
                            !value?.education?.length ?
                            null
                            : (
                              <div className={`card  border-0 shadow-sm ${mobileScreen ? "px-3" : "px-5"} py-3 mb-4 placeholder-glow`} >
                                <div className="row" id={i === 0 ? "firstCard" : ""}>
                                  <div className="card-header bg-transparent d-flex justify-content-between align-items-center">
                                    <p className={pageContentLoaded ? "mb-1" : "placeholder py-2 rounded-2"} >
                                      USER ID :{" "}
                                      <strong>{value.professional_id}</strong>
                                    </p>

                                    <div className={`d-flex flex-wrap justify-content-end col-xl-3`} id={`viewFullProfile${value.id}Button`} >
                                      <button
                                        type="button"
                                        className={'btn border-brand-color py-1'}
                                        data-bs-toggle="modal"
                                        data-bs-target="#fullProfileModal"
                                        onClick={() => setProfessionalId(value.professional_id)}
                                      >
                                        View full profile
                                      </button>

                                      <button
                                        type="button"
                                        className="btn  btn-transparent border border-brand-color candidate-right-side-btn ms-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#shareModal"
                                        onClick={() => setShareProfessional(value.professional_id)}
                                      >
                                        <FaShare />
                                        <span className='ps-2'>Share</span>
                                      </button>
                                    </div>
                                  </div>

                                  {value.about.length === 0 ? null : (
                                    <div className="col-lg-6 col-md-12 ">
                                      <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                          <FaUserTie
                                            className={
                                              pageContentLoaded
                                                ? "me-4 brand-color fs-4"
                                                : "me-4  fs-4 placeholder rounded-2"
                                            }
                                          />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent={
                                          value.about.length > 200
                                            ? `${value.about.slice(0, 250)}..`
                                            : `${value.about}`
                                        }
                                        mobileScreen={mobileScreen}
                                      />
                                    </div>
                                  )}

                                  {value.experience.length === 0 ? null : (
                                    <div className="col-lg-6 col-md-12">
                                      <InfoAddCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                          <PiBagFill
                                            className={
                                              pageContentLoaded
                                                ? "me-4 brand-color fs-4"
                                                : "me-4  fs-4 placeholder rounded-2"
                                            }
                                          />
                                        }
                                        cardHeading="Experience"
                                        placeholder="Your experience details will be displayed here"
                                        arrayContent={value.experience[0]}
                                        currentPage="employerPool"
                                        mobileScreen={mobileScreen}
                                      />
                                    </div>
                                  )}
                                  {value.skills.length === 0 ? null : (
                                    <div className="col-lg-6 col-md-12">
                                      <div className="card mt-3 border-0 rounded-4">
                                        <div
                                          className={`card-body ${mobileScreen ? "px-0 py-0" : ""
                                            }`}
                                        >
                                          <div className="d-flex justify-content-between ms-1">
                                            <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                              <HiLightBulb
                                                className={
                                                  pageContentLoaded
                                                    ? "me-4 brand-color fs-4"
                                                    : "me-4  fs-3 placeholder rounded-2"
                                                }
                                              />
                                              <span
                                                className={
                                                  pageContentLoaded
                                                    ? ""
                                                    : "placeholder px-3 w-100 py-1  rounded-1"
                                                }
                                              >
                                                Skills
                                              </span>
                                            </label>
                                          </div>

                                          <div className="d-flex justify-content-between align-items-center">
                                            <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                              {value.skills.length === 0 ? (
                                                <p
                                                  className={
                                                    pageContentLoaded
                                                      ? "mt-0 word-space-content px-0 ms-1"
                                                      : "placeholder px-3 py-2 mt-0 rounded-1"
                                                  }
                                                >
                                                  Your skills will be displayed here
                                                </p>
                                              ) : (
                                                value.skills
                                                  .slice(0, 5)
                                                  .map((skill, id) => {
                                                    return (
                                                      <React.Fragment key={skill.id}>
                                                        <div className="col mt-0  px-0 me-2">
                                                          <div
                                                            className={
                                                              pageContentLoaded
                                                                ? "border rounded-2 p-2 fw-bold mb-3 "
                                                                : "border rounded-2 p-2 fw-bold mb-4 placeholder"
                                                            }
                                                          >
                                                            <span className="textTransform">
                                                              {skill.skill_name}
                                                            </span>{" "}
                                                            {skill.skill_level
                                                              ? "-"
                                                              : null}{" "}
                                                            <span className="fw-normal">
                                                              {skill.skill_level}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </React.Fragment>
                                                    );
                                                  })
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {value.education.length === 0 ? null : (
                                    <div className="col-lg-6 col-md-12">
                                      <InfoAddCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                          <FaGraduationCap
                                            className={
                                              pageContentLoaded
                                                ? "me-4 brand-color fs-4"
                                                : "me-4  fs-4 placeholder rounded-2"
                                            }
                                          />
                                        }
                                        cardHeading="Education"
                                        placeholder="Your education details will be displayed here"
                                        arrayContent={value.education[0]}
                                        currentPage="employerPool"
                                        mobileScreen={mobileScreen}
                                      />
                                    </div>
                                  )}
                                  <hr className={`mt-2 ${inviteInterviewBtn
                                    ? "d-block"
                                    : "visually-hidden"
                                    }`} />
                                </div>

                                <div className={`${inviteInterviewBtn ? "d-block" : "visually-hidden"}`}>
                                  <div className={`mt-4 ${mobileScreen ? "text-center" : "text-end"}`} id={`inviteToInterview${value.id}Button`}>
                                    <button id={`${i === 0 ? "clickToSeeProfile2" : ""}`} className={pageContentLoaded ? "btn btn-brand-color" : "btn  placeholder rounded-2"}
                                      onClick={() => handleInviteTonterview(value?.professional_id)}
                                      disabled={!Cookie.get("payment_status") || Cookie.get("payment_status") === "trialing"}
                                    >
                                      Invite to Apply
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                        </React.Fragment>
                      );
                    })
                    :
                    <div className="h-100">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="d-flex justify-content-center vh-80 align-items-center">
                          <img
                            src={images.noRecordsFound}
                            width={250}
                            height={250}
                          />
                        </div>
                      </div>
                    </div>
                }
              </div>

              <div className="pool_page_footer">
                {
                  totalNoOfRecords > 10 && pageContentLoaded && !filterGlow ?
                    <div className="col-12 col-md-10 col-lg-6">
                      <div className="w-100 pt-3">
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          breakLabel={'...'}
                          pageCount={Math.ceil(totalNoOfRecords / 10)}
                          forcePage={currentPage}
                          pageRangeDisplayed={1}
                          marginPagesDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName={"pagination justify-content-end"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      </div>
                    </div>
                    :
                    null
                }
              </div>
            </div>
        }
      </div >

      <div
        className="modal fade"
        id="fullProfileModal"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div
            className={`modal-content ${mobileScreen ? "px-0 " : "px-3"} mx-2 `}
          >
            <div className="modal-header border-bottom-0 ">
              <h1 className="modal-title fs-5 mt-2" id="staticBackdropLabel">
                Applicant full profile
              </h1>
              <button
                id="closeViewProfileButton"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body border-bottom-0" style={{ height: "25rem", overflowY: "scroll" }}>
              <div className="container px-0 h-100">
                {professionalId !== null ? (
                  <CandidateProfile
                    professionalId={professionalId}
                    mobileScreen={mobileScreen}
                  />
                ) : null}
              </div>
            </div>
            <div className="modal-footer border-top-0">
              <div className="container">
                <div className="row float-end">
                  <div className="col-lg-12 ">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      data-bs-dismiss="modal"
                    >
                      <span>Cancel</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* invite to interview model */}
      <div className="inviteInterview-modal-container">
        <Modal
          backdrop="static"
          keyboard={false}
          show={show}
          onHide={handleInterviewModal}
          size="lg"
          centered>

          <Modal.Header closeButton>
            <Modal.Title><h5 className="fw-bold p-2">Invite to Apply</h5></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="inviteInterview-modal-body d-flex flex-column p-3">
              {
                empJobGlow ?
                  <div className="spinner-modal-body-size">
                    <div className="col text-center">
                      <div className="spinner-border brand-color" role="status">
                        <span className="visually-hidden ">Loading...</span>
                      </div>
                      <p className="mt-2 text-secondary">Getting data...</p>
                    </div>
                  </div>
                  :
                  <Fragment>
                    <div className="inviteInterview-selectJob d-flex flex-column">
                      <h6 className="fw-bold">Please Select the Job</h6>

                      <Form.Select aria-label="Default select example" onChange={(e) => handleSelecJob(e.target.value)}>
                        <option value=""></option>
                        {empJobsData?.map((value, index) => (
                          <option value={JSON.stringify(value)} key={index} disabled={value?.job_status === "Applied"}>
                            {value?.job_title}

                            <span>
                              {value?.job_status === "Applied" ? `(${value?.job_status})` : null}
                            </span>
                          </option>
                        ))}
                      </Form.Select>

                    </div>
                    <div className="inviteInterview-InputText mt-4">
                      <h6 className="fw-bold ">Why would you like this professional to apply for this job?</h6>
                      <p className="fs-6">This message will be shared with the professional to provide context for the invitation. (Optional)</p>
                      <Form.Control as="textarea" rows={7} placeholder="Enter Your Text Here" onChange={(e) => setSendInviteData({ ...sendInviteData, employer_feedback: e.target.value })}></Form.Control>

                    </div>
                  </Fragment>
              }
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex w-100">
              <Button
                variant="outline-secondary"
                className="mx-2 w-50"
                disabled={empJobGlow}
                onClick={handleInterviewModal}
              >
                Cancel
              </Button>


              <Button
                variant="brand-color"
                className="w-50"
                onClick={handleInterviewApi}
                disabled={empJobGlow}
              >
                Invite
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>

      {/* share professional  */}
      <div
        className="modal fade"
        id="shareModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">  Share </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0 ">
              <div className="mb-3 position-relative">
                <label htmlFor="message-text" className="col-form-label">
                  Share Profile
                </label>
                <input
                  className="form-control  mx-auto mt-0 linkFieldSize"
                  id="message-text"
                  value={process.env.REACT_APP_SHARE_BASEURL + window.location.pathname + (window.location.pathname === "/partner_dashboard/pool" ? "?prof_id_partner=" : "?prof_id=") + encryptData(shareProfessional)}
                  readOnly
                />
                <button
                  type="button"
                  className="btn btn-brand-color button-position"
                  onClick={() => handleCopytext(process.env.REACT_APP_SHARE_BASEURL + window.location.pathname + (window.location.pathname === "/partner_dashboard/pool" ? "?prof_id_partner=" : "?prof_id=") + encryptData(shareProfessional))}
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {
        (pageContentLoaded && Cookie.get("isEmployerPoolFirstVisit")) ||
          Cookie.get("isPartnerPoolFirstVisit") ? (
          allArrayData.length === 0 ? (
            <Joyride
              callback={handleJoyrideCallbackForNoData}
              styles={{
                options: {
                  width: "500px",
                  borderRadius: "60px",
                },
                buttonNext: {
                  background: "#e38212",
                  outline: "none",
                },
                buttonSkip: {
                  textDecoration: "underline",
                },
                buttonBack: {
                  color: "#212529",
                  backgroundColor: "#fff",
                  border: " 0px",
                  borderRadius: "4px",
                  color: "#000",
                  cursor: "pointer",
                  fontSize: "16px",
                  lineHeight: "1",
                  padding: "8px",
                  appearance: "none",
                  outline: "1px solid grey",
                },
              }}
              scrollOffset={500}
              continuous
              disableOverlayClose={true}
              hideCloseButton
              showSkipButton
              showProgress
              steps={stepsForNoData}
              run={runForNoData}
            />
          ) : (
            <Joyride
              callback={handleJoyrideCallback}
              styles={{
                options: {
                  width: "500px",
                  borderRadius: "60px",
                },
                buttonNext: {
                  background: "#e38212",
                  outline: "none",
                },
                buttonSkip: {
                  textDecoration: "underline",
                },
                buttonBack: {
                  color: "#212529",
                  backgroundColor: "#fff",
                  border: " 0px",
                  borderRadius: "4px",
                  color: "#000",
                  cursor: "pointer",
                  fontSize: "16px",
                  lineHeight: "1",
                  padding: "8px",
                  appearance: "none",
                  outline: "1px solid grey",
                },
              }}
              scrollOffset={500}
              continuous
              disableOverlayClose={true}
              hideCloseButton
              showSkipButton
              showProgress
              steps={steps}
              run={run}
            />
          )
        ) : null
      }
    </>
  );
};

export default EmployerPool;